import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import ComicSection from './components/ComicSection';
import FeaturesSection from './components/FeaturesSection';
import CtaSection from './components/CtaSection';
import { hotComics, newComics, completedComics } from '@/mocks/comics';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '妖精漫画 - 免费漫画弹窗入口',
    description: '妖精漫画免费弹窗入口，支持下拉式在线阅读，主打奇幻、魔法、妖精题材漫画大全，涵盖韩漫、日漫、国漫等多种题材。',
    url: 'https://yaojingmanhua.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '妖精漫画',
      url: 'https://yaojingmanhua.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <ComicSection
          title="热门推荐"
          subtitle="大家都在看的精品漫画"
          comics={hotComics}
          viewAllLink="/category/fantasy"
          bgClass="bg-background-50"
        />
        <FeaturesSection />
        <ComicSection
          title="最新上架"
          subtitle="新鲜出炉的漫画佳作"
          comics={newComics}
          viewAllLink="/category/fairy"
          bgClass="bg-background-100"
        />
        <ComicSection
          title="已完结佳作"
          subtitle="一口气看到底的经典作品"
          comics={completedComics}
          viewAllLink="/category/romance"
          viewAllLabel="探索更多"
          bgClass="bg-background-50"
        />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}